export const mailCommand = {
  preview: 'preview',
  send: 'send',
  sendTenantEmail: 'sendTenantEmail',
  sendTenantMail: 'sendTennatMail',
  sendTenantSMS: 'sendTenantSMS',
};
